module.exports = __webpack_public_path__ + "Lato-Semibold.c2b50f4a7d908c8d06f5.woff";


//////////////////
// WEBPACK FOOTER
// /mnt/disk/stratbox.dev/src/assets/fonts/Lato/Lato-Semibold.woff
// module id = ../../../../../src/assets/fonts/Lato/Lato-Semibold.woff
// module chunks = styles